export default __webpack_public_path__ + "imgs/imgTopGuide.png";